var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHealthPilatesServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 110,
    viewBox: "0 0 115 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2141_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.8299 23.1289C98.4863 23.1289 99.1185 23.3387 99.6058 23.7785C102.422 26.3201 112.062 36.3792 112.062 55.0002C112.062 73.6211 102.422 83.6802 99.6058 86.2218C99.1185 86.6616 98.4863 86.8714 97.8299 86.8714H92.2315H79.9681C79.3454 86.8714 78.742 86.681 78.256 86.2918C75.0201 83.7005 62.485 72.5313 62.485 55.0002C62.485 37.469 75.0201 26.2998 78.256 23.7085C78.7421 23.3193 79.3454 23.1289 79.9681 23.1289H92.2315H97.8299Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0809,
    cy: 55.0002,
    rx: 31.8712,
    ry: 17.7062,
    transform: "rotate(90 80.0809 55.0002)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9416 23.1357C92.9416 23.1357 105.686 33.1968 105.686 54.9957C105.686 76.7945 92.9416 86.8556 92.9416 86.8556H83.3836C83.3836 86.8556 96.1276 75.1177 96.1276 54.9957C96.1276 34.8736 83.3836 23.1357 83.3836 23.1357H92.9416Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9056 45.4209C78.9056 45.4209 84.2715 48.4392 84.2715 54.9789C84.2715 61.5185 78.9056 64.5369 78.9056 64.5369H30.948C30.948 64.5369 26.9236 61.0155 26.9236 54.9789C26.9236 48.9423 30.948 45.4209 30.948 45.4209H78.9056Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6287 23.1289C38.2852 23.1289 38.9173 23.3387 39.4047 23.7785C42.2212 26.3201 51.8613 36.3792 51.8613 55.0002C51.8613 73.6211 42.2213 83.6802 39.4047 86.2218C38.9173 86.6616 38.2852 86.8714 37.6287 86.8714H19.7669C19.1442 86.8714 18.5409 86.681 18.0548 86.2918C14.819 83.7005 2.28384 72.5313 2.28384 55.0002C2.28384 37.469 14.819 26.2998 18.0548 23.7085C18.5409 23.3193 19.1442 23.1289 19.7669 23.1289H37.6287Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7684,
    cy: 55.0002,
    rx: 31.8712,
    ry: 17.7062,
    transform: "rotate(90 19.7684 55.0002)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1273 42.249C22.1273 42.249 26.9062 46.2734 26.9062 54.993C26.9062 63.7125 22.1273 67.737 22.1273 67.737H14.1623L10.9763 64.0958C10.9763 64.0958 10.9763 63.0418 10.9763 54.993C10.9763 46.9442 10.9763 45.8902 10.9763 45.8902L14.1623 42.249H22.1273Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2736 23.1357C33.2736 23.1357 46.0176 33.1968 46.0176 54.9957C46.0176 76.7945 33.2736 86.8556 33.2736 86.8556H23.7156C23.7156 86.8556 36.4596 75.1177 36.4596 54.9957C36.4596 34.8736 23.7156 23.1357 23.7156 23.1357H33.2736Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1788,
    cy: 54.9764,
    rx: 12.744,
    ry: 6.37198,
    transform: "rotate(90 14.1788 54.9764)",
    fill: "#B8B8B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2141_266",
    x: 0.0625,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2141_266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2141_266",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthPilatesServiceMain);
export default __webpack_public_path__ + "static/media/IcHealthPilatesServiceMain.ab13089258b1d07853e3123cd8af4911.svg";
export { ForwardRef as ReactComponent };